import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZDetailedAccountJournal } from './models';

const c = initContract();
export const adminPaymentContract = c.router(
  {
    getDetailedPlayerAccountJournal: {
      method: 'GET',
      path: '/:player_id/account-journal',
      pathParams: z.object({
        player_id: z.string(),
      }),
      query: z.object({
        page: z.coerce.number(),
        pageSize: z.coerce.number(),
      }),
      responses: {
        200: ZDetailedAccountJournal,
        404: c.type<{ message: 'Not Found'; reason: string }>(),
      },
      summary: 'Admin get player account journal',
    },
  },

  {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    jsonQuery: true,

    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
      403: c.type<{ message: string; statusCode: 403 }>(),
    },
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
  },
);
